import Koong from './../assets/Backspace_Koong.png';
import Menn from './../assets/Backspace_Menn.png';
import Menz from './../assets/Backspace_Menz.png';
import Noon from './../assets/Backspace_Noon.png';
import Obb from './../assets/Backspace_Obb.png';
import Tim from './../assets/Backspace_Tim.png';
import Ton from './../assets/Backspace_Ton.png';

export const BACKSPACE_TEAM_MEMBER = [
  {
    firstName: 'Panit',
    lastName: 'Panitruttiwong',
    position: 'Engineering & Construction System Manager',
    email: 'panitp@scg.com',
    responsibility:
      'Project owner and digital direction man to drive digital transformation in E&C Department',
    src: Obb
  },
  {
    firstName: 'Nawadech',
    lastName: 'Jamnoi',
    position: 'Solution Architect Engineer',
    email: 'nawadecj@scg.com',
    responsibility:
      'Project coordinator to collaborate between users and developer team',
    src: Ton
  },
  {
    firstName: 'Tulanan',
    lastName: 'Jiangpradit',
    position: 'Solution Architect Engineer',
    email: 'tulanunj@scg.com',
    responsibility:
      'System analysis to design the whole application and back-end development',
    src: Menn
  },
  {
    firstName: 'Chawakorn',
    lastName: 'Tanksinmankhong',
    position: 'Solution Architect Engineer',
    email: 'chawakot@scg.com',
    responsibility:
      'UX/UI designer to design the whole application and front-end development',
    src: Tim
  },

  {
    firstName: 'Wandee',
    lastName: 'Pattathom',
    position: 'Solution Architect Technician',
    email: 'wandepat@scg.com',
    responsibility: 'UX/UI designer and front-end development',
    src: Koong
  },
  {
    firstName: 'Anurak',
    lastName: 'Kaewpipob',
    position: 'Solution Architect Technician',
    email: 'anurakka@scg.com',
    responsibility:
      'IIoT solution development and consultant for plant automation ',
    src: Menz
  },
  {
    firstName: 'Chayaporn',
    lastName: 'Boonsong',
    position: 'IT Support & Administration',
    email: 'chayapbo@scg.com',
    responsibility: 'Operation support and first-tier to help users issue',
    src: Noon
  }
];
